import {action, observable} from 'mobx'
import uniqid from 'uniqid'
import {notification} from 'antd'

export class Messages {
  @observable count = 0
  @observable current_page = 0
  @observable total_pages = 0
  @observable results = []
  @observable merged = []
  @observable table = false

  constructor(rootStore, api) {
    this.root = rootStore
    this.api = api
  }

  @action load = async (id, ticker) => {
    let url = `sys/backtests/${id}/messages`
    if (ticker) {
      url += `?ticker=${ticker}`
    }

    const res = await this.api.request(url, 'get')
    const {current_page, total_pages, results} = res
    let {count} = res
    let table = false
    let keyed = []

    results.map(row => {
      if (row.display_as === 'notification') {
        notification['warning']({
          message: row.message
        })
        count--
      } else {
        row.key = uniqid()
        keyed.push(row)
      }
      if (row.date || row.ticker) {
        table = true
      }
    })

    this.count = count
    this.current_page = current_page
    this.total_pages = total_pages
    this.results = keyed
    this.table = table
  }
}
